import * as React from 'react'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import Icon from 'app/shared/components/Icon'

interface Props {
    /**
     * @param 약관 동의 상태
     */
    onChange?(isAllChecked: boolean): void
    /**
     부모 class
    */
    className?: string
}

const TermListCheckCard: React.FC<Props> = ({ className, onChange }) => {
    const [checkboxAll, setCheckboxAll] = React.useState(false)
    const [listToggle, setListToggle] = React.useState(true)

    // check 1dep
    const checkAgreeAll = [
        {
            id: 'agree4check1',
            name: '체크카드 개인회원 약관',
            required: true,
            view: true,
        },
        {
            id: 'agree4check2',
            name: '개인(신용)정보의 필수적 수집·이용',
            required: true,
            view: true,
        },
        {
            id: 'agree4check3',
            name: '개인(신용)정보의 필수적 조회',
            required: true,
            view: true,
        },
        {
            id: 'agree4check4',
            name: '개인(신용)정보의 필수적 제공',
            required: true,
            view: true,
        },
    ]
    const [checkAgree, setcheckAgree] = React.useState<boolean[]>(
        new Array(checkAgreeAll.length).fill(false)
    )
    const checkAgreeChange = (checked: boolean, index: number) => {
        let _checkAgree = [...checkAgree]
        _checkAgree[index] = checked
        setcheckAgree(_checkAgree)
        const newCheck = _checkAgree.concat(checkAgreeSub)
        for (let check of newCheck) {
            if (!check) {
                setCheckboxAll(false)
                onChange?.(false)
                return
            }
        }
        setCheckboxAll(true)
        onChange?.(true)
    }

    // check 2dep
    const checkAgreeSubItem = [
        {
            id: 'agree4checkSub1',
            name: '종합신용정보집중기관 및 신용정보회사',
        },
        { id: 'agree4checkSub2', name: '여신금융협회 등에 개인(신용)정보제공' },
        {
            id: 'agree4checkSub3',
            name: '고객이 요청한 서비스의 이행 유지를 위한 개인(신용) 정보 제공',
        },
    ]
    const [checkAgreeSub, setcheckAgreeSub] = React.useState<boolean[]>(
        new Array(checkAgreeSubItem.length).fill(false)
    )
    const checkAgreeSubChange = (checked: boolean, index: number) => {
        let _checkAgree = [...checkAgreeSub]
        _checkAgree[index] = checked
        setcheckAgreeSub(_checkAgree)
        const newCheck = _checkAgree.concat(checkAgree)
        for (let check of newCheck) {
            if (!check) {
                setCheckboxAll(false)
                onChange?.(false)
                return
            }
        }
        setCheckboxAll(true)
        onChange?.(true)
    }

    return (
        <div
            className={`checkboxs-agree ${className} ${
                listToggle ? '-open' : ''
            }`.trim()}
        >
            <div className="group">
                <div className="checkbox-basic -big">
                    <Checkbox
                        inputId="agree4checkAll"
                        value="agree4checkAll"
                        onChange={(e) => {
                            setCheckboxAll(e.checked)
                            onChange?.(e.checked)
                        }}
                        checked={checkboxAll}
                    />
                    <label htmlFor="agree4checkAll">모두 동의합니다</label>
                </div>
                <Button
                    className="btn-toggle"
                    onClick={() => setListToggle((prev) => !prev)}
                >
                    <Icon name="arrow-down" text="체크박스 항목 닫기"></Icon>
                </Button>
            </div>
            <div
                className="group-toggle"
                aria-hidden={listToggle ? false : true}
            >
                <div className="list">
                    {checkAgreeAll.map((item, index) => (
                        <div className="group" key={item.id}>
                            <div className="checkbox-basic">
                                <Checkbox
                                    inputId={item.id}
                                    value={item.id}
                                    name="checkAgree4"
                                    onChange={(e) => {
                                        checkAgreeChange(e.checked, index)
                                    }}
                                    checked={checkAgree[index]}
                                />
                                <label htmlFor={item.id}>
                                    {item.name}
                                    {item.required && (
                                        <span className="req">필수</span>
                                    )}
                                </label>
                            </div>
                            {item.view && (
                                <Button
                                    className="btn-view"
                                    label="보기"
                                    title={`${item.name} 약관보기`}
                                />
                            )}
                        </div>
                    ))}
                    <div className="group-subcheck">
                        {checkAgreeSubItem.map((item, index) => (
                            <div className="checkbox-basic -sub" key={index}>
                                <Checkbox
                                    inputId={item.id}
                                    value={item.id}
                                    name="checkAgree4Sub"
                                    onChange={(e) => {
                                        checkAgreeSubChange(e.checked, index)
                                    }}
                                    checked={checkAgreeSub[index]}
                                />
                                <label htmlFor={item.id}>{item.name}</label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TermListCheckCard
